module.exports = __webpack_public_path__ + "assets/img/seal-8f040e43.png";